import React, { useState, useEffect } from "react";
import { Popup } from "devextreme-react/popup";
import { Button } from "devextreme-react/button";
import TextBox from "devextreme-react/text-box";
import SelectBox from "devextreme-react/select-box";
import {
	getOrders,
	adminGeneratePayLink,
} from "../api/apiServiceFetch";

// Человекочитаемая категория тарифа (без эмодзи — см. правило по иконкам).
const typeLabels = {
	1: "Platinum",
	2: "Суперлайки",
	3: "Чистый лист",
	4: "Инкогнито",
	5: "Повторная регистрация",
};

const charIdToLabel = (value) => {
	if (!value) return "";
	if (value === "week") return "Неделя";
	if (value === "month") return "Месяц";
	if (value === "new") return "Чистый лист";
	if (value === "Retry") return "Повторная регистрация";
	if (value.startsWith("super")) return `Супер ${value.slice(5)}`;
	return value;
};

const GeneratePayLinkPopup = ({ visible, onClose, defaultUserId = "" }) => {
	const [userId, setUserId] = useState(defaultUserId);
	const [orderId, setOrderId] = useState(null);
	const [orders, setOrders] = useState([]);
	const [link, setLink] = useState("");
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setUserId(defaultUserId || "");
	}, [defaultUserId, visible]);

	useEffect(() => {
		if (!visible) return;
		(async () => {
			try {
				const data = await getOrders();
				const filtered = (data || []).filter(
					(o) => o.currency === "RUB" && o.isActive
				);
				setOrders(filtered);
			} catch (e) {
				console.error("getOrders failed:", e);
			}
		})();
	}, [visible]);

	const handleGenerate = async () => {
		if (!userId || Number(userId) <= 0) {
			alert("Введите ID пользователя");
			return;
		}
		if (!orderId) {
			alert("Выберите тариф");
			return;
		}
		setLoading(true);
		setLink("");
		try {
			const resp = await adminGeneratePayLink(Number(userId), orderId);
			setLink(resp?.paymentUrl || resp?.PaymentUrl || "");
		} catch (e) {
			alert("Ошибка: " + (e?.message || e));
		} finally {
			setLoading(false);
		}
	};

	const copyLink = async () => {
		if (!link) return;
		try {
			await navigator.clipboard.writeText(link);
			alert("Ссылка скопирована");
		} catch {
			alert("Не удалось скопировать");
		}
	};

	if (!visible) return null;

	return (
		<Popup
			visible={true}
			onHiding={onClose}
			showTitle={true}
			title="Сгенерировать ссылку для оплаты (TBank)"
			width={620}
			height={460}
			dragEnabled={true}
		>
			<div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
				<div>
					<div style={{ marginBottom: 6 }}>ID пользователя (внутренний id):</div>
					<TextBox
						value={String(userId ?? "")}
						mode="number"
						onValueChanged={(e) => setUserId(e.value)}
					/>
				</div>

				<div>
					<div style={{ marginBottom: 6 }}>Тариф:</div>
					<SelectBox
						items={orders.map((o) => ({
							value: o.orderId,
							text: `#${o.orderId} • ${typeLabels[o.type] ?? "—"} • ${charIdToLabel(
								o.charId
							)} • ${o.price} ${o.currency}${
								o.superLikes ? ` • ${o.superLikes} суперлайков` : ""
							}`,
						}))}
						displayExpr="text"
						valueExpr="value"
						value={orderId}
						onValueChanged={(e) => setOrderId(e.value)}
						searchEnabled={true}
						placeholder="Выберите тариф..."
					/>
				</div>

				<Button
					text={loading ? "Создание..." : "Сгенерировать"}
					type="default"
					disabled={loading}
					onClick={handleGenerate}
				/>

				{link && (
					<div
						style={{
							background: "#f5f5f5",
							padding: 12,
							borderRadius: 8,
							wordBreak: "break-all",
						}}
					>
						<div style={{ marginBottom: 8, fontSize: 12, color: "#666" }}>
							Ссылка:
						</div>
						<div style={{ marginBottom: 8 }}>
							<a href={link} target="_blank" rel="noreferrer">
								{link}
							</a>
						</div>
						<Button text="Скопировать" onClick={copyLink} />
					</div>
				)}

				<div style={{ textAlign: "right", marginTop: "auto" }}>
					<Button text="Закрыть" onClick={onClose} />
				</div>
			</div>
		</Popup>
	);
};

export default GeneratePayLinkPopup;
